// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';


export const addFuelMultiplier = async (
multiplier) =>
{
  const added = await fetchRequest.post('/fuelMultiplier', multiplier);
  if (added) return added;
  throw new Error('Не удалось создать топливынй коэффициент');
};

export const updateFuelMultiplier = async (
fuelMultiplier) =>
{
  const updated = await fetchRequest.put('/fuelMultiplier', fuelMultiplier);
  if (updated) return updated;
  throw new Error('Не удалось обновить топливный коэффициент');
};

export const fetchFuelMultipliers = async (
params = initialFetchListParams) =>

await fetchRequest.get('/fuelMultiplier', {
  ...initialFetchListParams,
  ...params
});

export const fetchFuelMultiplier = async (
id) =>
{
  const multiplier = await fetchRequest.get(`/fuelMultiplier/${id}`);
  if (multiplier) return multiplier;
  throw new Error('Не удалось загрузить коэффициент');
};

export const deleteFuelMultiplier = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/fuelMultiplier/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить коэффициент');
};

export const addVehicleFuelMultiplier = async (
vehicleId,
fuelMultplierId) =>
{
  const result = await fetchRequest.post(
    `/vehicle/${vehicleId}/fuelMultipliers/${fuelMultplierId}`
  );
  if (result) {
    return result;
  } else {
    throw new Error('Не удалось добавить коэффициент к ТС');
  }
};

export const fetchVehicleFuelMultipliers = async (
vehicleId) =>
{
  const result = await fetchRequest.get(
    `/vehicle/${vehicleId}/fuelMultipliers`
  );
  if (result) {
    return result;
  } else {
    throw new Error('Не удалось получить топливные коэффициенты');
  }
};

export const deleteVehicleFuelMultiplier = async (
vehicleId,
multiplierId) =>
{
  const result = await fetchRequest.delete(
    `/vehicle/${vehicleId}/fuelMultipliers/${multiplierId}`
  );
  if (!result) {
    throw new Error('Не удалось получить топливные коэффициенты');
  }
};

export default {
  addVehicleFuelMultiplier,
  addFuelMultiplier,
  updateFuelMultiplier,
  fetchFuelMultipliers,
  deleteFuelMultiplier,
  fetchFuelMultiplier,
  fetchVehicleFuelMultipliers,
  deleteVehicleFuelMultiplier
};
